{
  "sdk-download-android": "Завантажити для Android",
  "sdk-connect": "Підключитись",
  "sdk-download-ios": "Завантажити для iOS",
  "sdk-install": "Встановити",
  "sdk-modal-instruct-1": "1. Відкрийте застосунок Binance",
  "sdk-modal-instruct-2": "2. Торкніться {{icon}} на головному екрані",
  "sdk-modal-title": "Підключіться до Binance",
  "sdk-no-app": "Ще не маєте застосунку Binance?"
}